import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoPanelBarMixin from './KendoPanelBarMixin'

export default {
    name: 'kendo-panelbar',
    mixins: [ KendoPanelBarMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/index.js